<template>
	<div class="text-dark">
    <div class="hidden lg:flex px-5">
      <div class="w-4/12">Product</div>
      <div class="w-2/12 pl-6">Inco Term</div>
      <div class="w-1/12">Price</div>
      <div class="w-2/12 px-8">Quantity</div>
      <div class="w-1/12 pl-4">Total</div>
    </div>
    <div
      v-for="(item, index) in products"
      :key="`cart-item-${index}`"
      class="bg-white mb-5 rounded-lg flex flex-wrap p-5 items-center border border-dark-b"
    >
      <div class="w-full lg:w-4/12 flex pb-4 lg:pb-0">
        <img :src="item.images[0]" class="w-20 h-20">
        <div class="pl-2.5 md:pl-5 py-2">
          <router-link :to="`/${item.slug}`">
            {{ item.name }}
          </router-link>
        </div>
      </div>
      <div class="w-3/5 md:w-1/2 lg:w-2/12 lg:pl-6 ml-auto pb-3 lg:pb-0">
        {{ item.inco_terms }}
      </div>
      <div class="w-3/5 md:w-1/2 lg:w-1/12 ml-auto pb-3 lg:pb-0">
        {{ calculateItemPrice(item) | currency }}
      </div>
      <div class="relative w-3/5 md:w-1/2 lg:w-2/12 lg:px-4 ml-auto pb-3 lg:pb-0">
        <QuantityChanger
          :product="item"
          :quantity="item.quantity"
          @setQuantity="quantity => item.quantity = quantity"
          @changeQuantity="quantity => changeItemQuantity(quantity, item, index)"
        />
      </div>
      <div class="w-3/5 md:w-1/2 lg:w-1/12 lg:pl-4 ml-auto pb-3 lg:pb-0">
        {{ itemTotal(item) | currency }}
      </div>
      <div class="w-3/5 md:w-1/2 lg:w-2/12 flex md:justify-end text-dark ml-auto">
        <button
          class="bg-dark-b px-4 py-1 rounded-full flex items-center text-opacity-50"
          @click="removeItemFromCart(item, index)"
        >
          <i class="icon-remove"/>
          <span class="pl-2.5">Remove</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import debounce from '@/services/debounce'
import ProductDetails from '@/shared/mixins/ProductDetails'
import QuantityChanger from '@/shared/components/product/productInfo/QuantityChanger'

export default {
	name: 'CartProductsTable',
  mixins: [ ProductDetails ],
	components: {
		QuantityChanger
	},
	props: {
		products: {
			required: true,
			type: Array
		}
	},
  created() {
    this.products.forEach((product) => {
        window.ga('ec:addProduct', {
          id: product.productId,                            // Transaction ID. Required.
          name: product.name,                       // Product name. Required. 
          sku: product.sku,                        // SKU/code.
          category: product.categoryName,         // Category or variation.
          quantity: product.quantity,
          price : this.calculateItemPrice(product),
          brand: product.brand
      });
    });
    
      window.ga('ec:setAction','checkout', {
          'step': 1,            // A value of 1 indicates this action is first checkout step.
          'option': 'Product Summary'      // Used to specify additional info about a checkout stage, e.g. payment method.
      });
      window.ga('send', 'pageview');
  },
	methods: {
		...mapActions ([
      'updateUserCartItemQuantity',
      'updateGuestCartItemQuantity'
    ]),
    itemTotal(item) {
      const total = this.calculateItemPrice(item) * item.quantity
      return total.toFixed(3)
    },
    changeItemQuantity(quantity, product, index) {
      product.quantity = parseInt(quantity)
      if (this.isUserLoggedIn) {
        this.updateUserItemQuantity({
          quantity,
          product,
          index
        })
      } else {
        this.updateGuestCartItemQuantity({
          quantity,
          index
        })
      }
    },
    updateUserItemQuantity: debounce( function (payload) {
      this.updateUserCartItemQuantity(payload)
    }, 400)
	}
}
</script>
